<template>
  <el-dialog
    custom-class="import-dialog"
    title="选择优惠券"
    :visible="visible"
    width="1200px"
    @close="close"
  >
    <div class="flex filter-wrapper">
      <div class="flex-1 mr10 w50">
        <div class="panel flex item-center flex-between">
          <div class="form-wrapper flex flex-wrap mb20">
            <!-- <el-select
              class="mr10"
              size="small"
              clearable
              placeholder="选择发放类型"
              v-model="sendWayType"
            >
              <el-option
                v-for="(item, i) in sendWayTypeOption"
                :key="i"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select> -->
            <!-- <el-select
              class="mr10"
              size="small"
              clearable
              placeholder="选择发放限制"
              v-model="event"
              :disabled="sendWayType !== 0 && sendWayType !== 4"
            >
              <el-option
                v-show="sendWayType === item.sendWayType"
                v-for="(item, i) in eventOption"
                :key="i"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select> -->
            <el-select
              class="mr10"
              size="small"
              clearable
              placeholder="选择发放对象"
              v-model="sendTarget"
            >
              <el-option
                v-for="(item, i) in sendTargetOption"
                :key="i"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
            <el-select
              size="small"
              clearable
              placeholder="选择会员类型"
              v-model="isPlus"
              style="width: 150px"
              class="mr10"
            >
              <el-option
                v-for="item in members"
                :key="item.value"
                :label="item.name"
                :value="item.value"
              ></el-option>
            </el-select>
            <el-input
              class="mr10"
              size="small"
              clearable
              placeholder="输入发放名称/副标题查询"
              v-model.trim="keywords"
              style="width: 150px"
            ></el-input>
            <el-button class="ml0" size="small" type="primary" @click="search"
              >查询</el-button
            >
          </div>
        </div>
        <div class="table">
          <!-- <div class="flex table-panel">
            <span
              class="btn"
              :class="{ active: v.index === activeTab }"
              @click="switchTab(v.index)"
              v-for="(v, i) in btnList"
              :key="i"
            >{{ v.name }}</span>
          </div> -->
          <div class="send-table">
            <div class="tips mb20" style="color: #e4393c">
              仅显示个人中心{{
                onlyQueryPlusCoupon ? "PLUS会员专享" : ""
              }}领券，点击发放名即可查询优惠券
            </div>
            <el-table
              stripe
              border
              @current-change="handleCurrentChange"
              highlight-current-row
              @selection-change="getChecked"
              :data="sendCouponsList"
              style="width: 100%"
              id="table"
              size="small"
            >
              <el-table-column
                header-align="center"
                align="center"
                type="index"
                label="序号"
                width="50"
                :index="index => index + (currentPage - 1) * pageSize + 1"
              ></el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                label="发放名称"
              >
                <template slot-scope="scope">
                  <span
                    v-if="scope.row.status !== 0"
                    class="coupon-name pointer"
                    @click="toDetail(scope.row)"
                    >{{ scope.row.name }}</span
                  >
                  <span v-else>{{ scope.row.name }}</span>
                </template>
              </el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="remark"
                label="副标题"
              ></el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="sendWayTypeFormat"
                label="发放类型"
              ></el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="eventFormat"
                label="发放限制"
              ></el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                label="发放时间"
                width="200"
              >
                <template slot-scope="scope">
                  <el-button
                    size="small"
                    type="text"
                    @click="getSendTime(scope.row.id)"
                    v-if="
                      scope.row.sendWayType !== 1 &&
                        scope.row.sendTimeStrategyType !== 4
                    "
                    >{{ scope.row.sendDate }}</el-button
                  >
                  <span
                    v-else-if="
                      scope.row.sendWayType !== 1 &&
                        scope.row.sendTimeStrategyType === 4
                    "
                    style="font-size: 12px;"
                  >
                    {{
                      `${scope.row.sendStartDate} ${
                        scope.row.sendStartTime.split(",")[0]
                      }`
                    }}
                    <br />
                    至{{
                      `${scope.row.sendEndDate} ${
                        scope.row.sendEndTime.split(",")[0]
                      }`
                    }}
                  </span>
                  <span
                    v-else-if="scope.row.sendWayType === 1"
                    style="font-size: 12px;"
                    >{{ scope.row.createTimeFormat }}</span
                  >
                </template>
              </el-table-column>
              <el-table-column
                header-align="center"
                align="center"
                prop="sendNumFormat"
                label="发放数量"
              ></el-table-column>
              <!-- <el-table-column  header-align="center" align="center"  prop="name" label="领取数量">
            </el-table-column>
            <el-table-column  header-align="center" align="center"  prop="name" label="使用数量">
              </el-table-column>-->
              <el-table-column
                header-align="center"
                align="center"
                label="状态"
              >
                <template slot-scope="scope">{{
                  activeTab === 2 ? "已作废" : scope.row.statusFormat
                }}</template>
              </el-table-column>
            </el-table>
          </div>
        </div>
        <div class="hm-pagination mb20">
          <el-pagination
            background
            :total="sendCouponsListTotal"
            @current-change="paging"
            @size-change="handleSizeChange"
            layout="total, sizes, prev, pager, next, jumper"
            :current-page="currentPage"
          ></el-pagination>
        </div>
      </div>
      <div class="filter-result flex-1 w50" v-if="result.length">
        <el-table
          ref="couponTable"
          @selection-change="getChecked"
          border
          :data="result"
        >
          <el-table-column type="selection"></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            type="index"
            label="序号"
            width="50"
            :index="index => index + (currentPage - 1) * pageSize + 1"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="name"
            label="券名"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="levelMin"
            label="使用门槛"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="account"
            label="减免金额"
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            prop="isPlusFormat"
            label="会员类型"
          ></el-table-column>
        </el-table>
      </div>
    </div>
    <div class="btn-wrapper mb20 flex flex-center">
      <el-button size="small" type="primary" @click="save">确 定</el-button>
      <el-button size="small" @click="close">取 消</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { mapState } from "vuex";

export default {
  props: {
    onlyQueryPlusCoupon: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ""
    },
    visible: {
      type: Boolean,
      default: false
    }
  },
  computed: mapState({
    cdkey: state => state.rules.cdkey,
    sendCouponsListTotal: state => state.rules.sendCouponsListTotal,
    invalidateCouponCode: state => state.rules.invalidateCouponCode,
    sendCouponsList: state => state.rules.sendCouponsList,
    publishCouponCode: state => state.rules.publishCouponCode,
    sendValidTime: state => state.rules.sendValidTime
  }),
  components: {},
  data() {
    return {
      result: [],
      sort: {},
      keyWords: "",
      currentRow: {},
      tHeader: [],
      tBody: [],
      dialogVisible: false,
      importTempVisible: false,
      checkedRow: [],
      batchCondition: {
        oldWord: "",
        newWord: "",
        categoryId: [],
        salesState: "open",
        spuPlatFormList: [],
        delFlag: 0,
        spuIdList: []
      },
      searchCondition: {},
      activityChildCategoryList: [],
      currentPage: 1,
      startDate: "",
      endDate: "",
      timeStatus: "",
      pageSize: 10,
      date: [],
      promotionCode: "",
      promotionName: "",
      enabledState: "",
      isOutputing: false,

      status: "1",
      showCdkModal: false,
      sendWayType: "5",
      event: "self",
      sendTarget: "",
      timeDialogVisible: false,
      value: "",
      keywords: "",
      url: "",
      activityCode: "",
      remark: "",
      isPlus: "",
      members: [
        { name: "PLUS会员", value: 0 },
        { name: "全部会员", value: 1 }
      ],
      sendWayTypeOption: [
        {
          value: 0,
          label: "自动发放"
        },
        {
          value: 1,
          label: "手动发放"
        },
        {
          value: 2,
          label: "自助领券"
        },
        {
          value: 3,
          label: "兑换码领取"
        },
        {
          value: 4,
          label: "活动发放"
        }
      ],
      eventOption: [
        {
          value: "registe",
          label: "开卡绑定",
          sendWayType: 0
        },
        {
          value: "follow",
          label: "关注公众号",
          sendWayType: 0
        },
        {
          value: "levelup",
          label: "升级plus会员",
          sendWayType: 0
        },
        {
          value: "orderOffline",
          label: "门店交易",
          sendWayType: 0
        },
        {
          value: "orderOnline",
          label: "线上交易",
          sendWayType: 0
        },
        {
          value: "recharge",
          label: "充值发放",
          sendWayType: 0
        },
        {
          value: "PasswordRedEnvelope",
          label: "口令红包",
          sendWayType: 0
        },
        {
          value: "bigturntable",
          label: "大转盘",
          sendWayType: 0
        },
        {
          value: "repository",
          label: "母婴知识库",
          sendWayType: 0
        },
        {
          value: "wyethNewCustomer",
          label: "惠氏新客",
          sendWayType: 0
        },
        {
          value: "share",
          label: "分享发券",
          sendWayType: 0
        },
        {
          value: "buy",
          label: "购买发券",
          sendWayType: 0
        },
        {
          value: "charge",
          label: "核销发券",
          sendWayType: 0
        },
        {
          value: "exchangeByPoint",
          label: "积分兑换",
          sendWayType: 4
        },
        {
          value: "carnival",
          label: "满额领券",
          sendWayType: 4
        }
      ],
      sendTargetOption: [
        {
          value: 0,
          label: "所有用户"
        },
        {
          value: 1,
          label: "指定用户"
        },
        {
          value: 2,
          label: "指定导购"
        },
        {
          value: 3,
          label: "指定门店"
        }
      ],
      activeTab: 1,
      btnList: [
        { name: "发放中", index: 1 },
        { name: "待发布", index: 0 },
        { name: "已过期", index: 5 },
        { name: "已作废", index: 3 },
        { name: "全部", index: 4 }
      ]
    };
  },
  watch: {},
  created() {},
  mounted() {
    this.queryList();
  },
  methods: {
    save() {
      if (!this.checkedRow.length) {
        this.$message({
          type: "warning",
          message: "请先选择优惠券"
        });
      } else {
        this.$emit("saveCoupon", this.checkedRow);
      }
      this.$refs.couponTable.clearSelection();
    },
    handleCurrentChange(row) {
      this.currentRow = row;
      this.queryChildren(row);
    },
    close() {
      this.$emit("close");
    },
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.queryList();
    },
    paging(page) {
      this.currentPage = page;
      this.queryList();
    },
    async queryChildren(row) {
      const { result } = await this.$store.dispatch("querySingleCouponList", {
        couponSendId: row.couponSendId
      });
      this.result.push(...result);
      this.result.forEach(item => {
        item.isPlusFormat =
          item.isPlus === 0
            ? "PLUS会员"
            : item.isPlus === 1
            ? "全部会员"
            : "全部会员";
        if (item.sendStartDate && item.sendEndDate) {
          item.dateTime = item.sendStartDate + "至" + item.sendEndDate;
        } if(item.ruleStartDate && item.ruleEndDate){
          item.dateTime = item.ruleStartDate +' '+ item.ruleStartTime.split(",")[0]  + "至" + item.ruleEndDate +' '+ item.ruleEndTime.split(",")[0];
        } else {
          item.dateTime = "";
        }
      });
    },
    async queryList(queryAll) {
      let params = {
        status: 1,
        sendWayType: this.sendWayType,
        type: this.sendTarget,
        event: this.event,
        isPlus: 1,
        keywords: this.keywords,
        pageSize: 10,
        pageNo: this.currentPage
      };
      if (this.onlyQueryPlusCoupon) {
        Object.assign(params, {
          isPlus: 0
        });
      }
      await this.$store.dispatch("querySendCoupons", params);
    },
    getChecked(selection) {
      this.checkedRow = selection;
    },
    search() {
      this.currentPage = 1;
      this.queryList();
    }
  }
};
</script>
<style lang="scss" scoped>
.btn {
  cursor: pointer;
  font-size: 0.875rem;
  color: #999;
  padding: 8px 20px;
  transition: background 0.1s linear;
}

.btn.active {
  background: #e50065;
  color: #fff;
  border-radius: 5px;
}

.table-panel {
  margin: 20px 0;
}

.filter-wrapper {
  padding: 20px;
}
.btn-wrapper {
  padding-bottom: 20px;
}

.filter-result {
  width: 300px;
}

.w50 {
  width: 50%;
}
</style>
